<cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-detail-manual">
      <thead>
        <tr>
          <th style="width: 20%">{{ "DatumOderBelegOderEntstehung" | translate }}</th>
          <th style="width: 5%">{{ "Art" | translate }}</th>
          <th style="width: 55%">{{ "Bezeichnung" | translate }}</th>
          <th style="width: 20%">{{ "DatumOderBeleg" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (lastRechtRootEntryVm of listLoader?.items; let i = $index; track i) {
          <!-- Kopfzeile -->
          <ng-template
            [ngTemplateOutlet]="kopfzeile"
            [ngTemplateOutletContext]="{
              lastRechtRootEntryVm: lastRechtRootEntryVm,
              odd: i % 2
            }"></ng-template>
          @if (lastRechtRootEntryVm.isPfandrecht) {
            <ng-template
              [ngTemplateOutlet]="imNachgangZu"
              [ngTemplateOutletContext]="{
                lastRechtRootEntryVm: lastRechtRootEntryVm,
                odd: i % 2
              }"></ng-template>
          } @else {
            <ng-template
              [ngTemplateOutlet]="nachgangStandardrecht"
              [ngTemplateOutletContext]="{
                rangregelungen: lastRechtRootEntryVm.rangregelungen,
                odd: i % 2
              }"></ng-template>
          }
        }
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #kopfzeile let-lastRechtRootEntryVm="lastRechtRootEntryVm" let-odd="odd">
  @if (lastRechtRootEntryVm.isPfandrecht && lastRechtRootEntryVm.pfandrechtMasterVm) {
    <ng-template
      [ngTemplateOutlet]="kopfzeilePfandrecht"
      [ngTemplateOutletContext]="{
        lastRechtRootEntryVm: lastRechtRootEntryVm,
        odd: odd
      }">
    </ng-template>
  } @else if (!lastRechtRootEntryVm.isPfandrecht) {
    <ng-template
      [ngTemplateOutlet]="kopfzeileStandardrecht"
      [ngTemplateOutletContext]="{
        lastRechtRootEntryVm: lastRechtRootEntryVm,
        odd: odd
      }">
    </ng-template>
  }
</ng-template>

<ng-template #kopfzeileStandardrecht let-lastRechtRootEntryVm="lastRechtRootEntryVm" let-odd="odd">
  @for (versionVm of lastRechtRootEntryVm?.standardRechtMasterVm.versionenVm; let last = $last; track $index) {
    <tr [ngClass]="{ abstandOben: last, even: !odd, odd: odd }">
      <td>
        <div [capHistinfo]="versionVm.histInfo">
          {{ versionVm.object.beginndatum | datum }}
          <cap-kompakt-beleg
            [enableNavigation]="isGeschaeftsmodulCapWebErweiterung"
            [histInfo]="versionVm.histInfo"
            [item]="versionVm.object.beleg"
            [referenzObjectId]="versionVm.object?.id?.id"
            [referenzObjectType]="'STANDARDRECHT'">
          </cap-kompakt-beleg>
        </div>
      </td>
      <td>
        <div>
          @for (belastungsArt of lastRechtRootEntryVm.belastungsArten; let i = $index; track i) {
            {{ belastungsArt | translate }} {{ i + 1 < lastRechtRootEntryVm.belastungsArten.length ? "," : "" }}
          }
        </div>
      </td>
      <td>
        <div>
          <cap-kompakt-standardrecht
            [histInfo]="versionVm.histInfo"
            [recht]="lastRechtRootEntryVm.object"
            [textLimit]="200"
            [version]="versionVm.object"
            format="STANDARDRECHT_TYP01"></cap-kompakt-standardrecht>
        </div>
      </td>
      <td></td>
    </tr>
  }
</ng-template>

<ng-template #kopfzeilePfandrecht let-lastRechtRootEntryVm="lastRechtRootEntryVm" let-odd="odd">
  @for (versionVm of lastRechtRootEntryVm?.pfandrechtMasterVm.versionenVm; let last = $last; track $index) {
    <tr [ngClass]="{ even: !odd, odd: odd }">
      <td>
        <div>
          <cap-kompakt-beleg
            [histInfo]="serialHistInfos([versionVm.lastBelastungVersion.histInfo, versionVm.object.histInfo])"
            [item]="versionVm.lastBelastungVersion.beleg"
            [referenzObjectId]="versionVm.lastBelastungVersion.id?.id"
            [referenzObjectType]="'GRUNDPFANDRECHT'"
            format="BELEG_TYP01">
          </cap-kompakt-beleg>
        </div>
      </td>
      <td>{{ "Belastet" | translate }}</td>
      <td>
        <div>
          <cap-kompakt-grundpfandrecht
            [histInfo]="
              serialHistInfos([
                versionVm.lastBelastungVersion.histInfo,
                lastRechtRootEntryVm?.pfandrechtMasterVm.versionenVm[0].object.histInfo
              ])
            "
            [masterId]="lastRechtRootEntryVm.pfandrechtMasterVm.object.id"
            [pfandstelle]="versionVm.lastBelastungVersion.pfandstelle"
            [rechteId]="lastRechtRootEntryVm.pfandrechtMasterVm.object.rechteId"
            [version]="lastRechtRootEntryVm?.pfandrechtMasterVm.versionenVm[0].object"
            format="GRUNDPFANDRECHT_TYP01">
          </cap-kompakt-grundpfandrecht>
        </div>
      </td>
      <td></td>
    </tr>
  }
</ng-template>

<ng-template #nachgangStandardrecht let-odd="odd" let-rangregelungen="rangregelungen">
  @for (rangregelung of rangregelungen; let first = $first; track $index) {
    <tr [ngClass]="{ even: !odd, odd: odd }">
      @if (rangregelung.object?.geschaeftsnummer) {
        <td class="table-subelements">
          @if (first) {
            {{ "imNachgangZu" | translate }}
          }
        </td>
        <td></td>
        <td class="ps-4">
          @if (rangregelung.object.vorgaengerMaster?.art === "PFANDRECHT") {
            <cap-kompakt-grundpfandrecht
              [histInfo]="rangregelung.object.histInfo"
              [masterId]="rangregelung.object.vorgaengerMaster.id"
              [rechteId]="rangregelung.object.vorgaengerMaster.rechteId"
              [version]="rangregelung.object.vorgaengerMaster.version"
              format="GRUNDPFANDRECHT_TYP01"></cap-kompakt-grundpfandrecht>
          } @else {
            <cap-kompakt-standardrecht
              [histInfo]="rangregelung.object.histInfo"
              [recht]="rangregelung.object.vorgaengerMaster"
              [textLimit]="200"
              format="STANDARDRECHT_TYP01">
            </cap-kompakt-standardrecht>
          }
          @if (!rangregelung.isSelfReference && rangregelung.object.grundstueck) {
            <span [capHistinfo]="rangregelung.object.histInfo">{{ "auf" | translate }}</span>
            @if (rangregelung.object.grundstueck) {
              <cap-kompakt-grundstueck
                [capHistinfo]="rangregelung.object.histInfo"
                [item]="rangregelung.object.grundstueck"></cap-kompakt-grundstueck>
            }
          }
          <cap-kompakt-timepoint [item]="rangregelung.object?.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
        </td>
        <td class="pt-0">
          @if (rangregelung.object.belegEntry) {
            <cap-kompakt-beleg
              [histInfo]="rangregelung.object.histInfo"
              [item]="rangregelung.object.belegEntry"
              [referenzObjectId]="rangregelung.object.vorgaengerMaster?.id?.id"
              [referenzObjectType]="rangregelung.object.vorgaengerMaster?.art"
              format="BELEG_TYP01">
            </cap-kompakt-beleg>
          }
          @if (rangregelung.object.bemerkung) {
            <cap-read-more [limit]="40" [text]="rangregelung.object.bemerkung"></cap-read-more>
          }
        </td>
      }
    </tr>
  }
</ng-template>

<ng-template #imNachgangZu let-lastRechtRootEntryVm="lastRechtRootEntryVm" let-odd="odd">
  @for (rangregelung of lastRechtRootEntryVm.rangregelungen; let first = $first; track $index) {
    <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
      @if (rangregelung.geschaeftsnummer) {
        <td class="table-subelements">
          {{ first ? ("imNachgangZu" | translate) : "" }}
        </td>
        <td></td>
        <td
          [capHistinfo]="
            serialHistInfos([
              lastRechtRootEntryVm.lastVersion.histInfo,
              lastRechtRootEntryVm?.pfandrechtMasterVm.versionenVm[0].object.histInfo
            ])
          "
          class="ps-4">
          @if (rangregelung.vorgaengerMaster.art === "PFANDRECHT") {
            <cap-kompakt-grundpfandrecht
              [histInfo]="
                serialHistInfos([
                  lastRechtRootEntryVm.lastVersion.histInfo,
                  lastRechtRootEntryVm?.pfandrechtMasterVm.versionenVm[0].object.histInfo
                ])
              "
              [masterId]="rangregelung.vorgaengerMaster.id"
              [rechteId]="rangregelung.vorgaengerMaster.rechteId"
              [version]="rangregelung.vorgaengerMaster.version"
              format="GRUNDPFANDRECHT_TYP01">
            </cap-kompakt-grundpfandrecht>
          } @else {
            <cap-kompakt-standardrecht
              [histInfo]="
                serialHistInfos([
                  lastRechtRootEntryVm.lastVersion.histInfo,
                  lastRechtRootEntryVm?.pfandrechtMasterVm.versionenVm[0].object.histInfo
                ])
              "
              [recht]="rangregelung.vorgaengerMaster"
              [textLimit]="200"
              format="STANDARDRECHT_TYP01"></cap-kompakt-standardrecht>
          }
          @if (rangregelung.grundstueck && rangregelung.grundstueck.id.id !== lastRechtRootEntryVm.id?.id) {
            <span> {{ "auf" | translate }} </span>
            <cap-kompakt-grundstueck [item]="rangregelung.grundstueck"></cap-kompakt-grundstueck>
          }
        </td>
        <td class="pt-0">
          <cap-kompakt-beleg
            [histInfo]="rangregelung.histInfo"
            [item]="rangregelung.belegEntry"
            [referenzObjectId]="rangregelung.vorgaengerMaster.id?.id"
            [referenzObjectType]="rangregelung.vorgaengerMaster.art"
            format="BELEG_TYP01">
          </cap-kompakt-beleg>
          @if (rangregelung.bemerkung) {
            <cap-read-more [limit]="40" [text]="rangregelung.bemerkung"></cap-read-more>
          }
        </td>
      }
    </tr>
  }
</ng-template>
